import React from 'react'
import "./ZipView.css";

function ZipView({currentZip, handleZip}) {
    return (
        <>
            <h2>Bitte geben Sie zuerst Ihre Postleitzahl des <span style={{textDecoration: "underline"}}>Bauvorhabens</span> ein.</h2>
            <input type="number" id="zip" className="zip" name="zip"
              value={currentZip}
              placeholder={currentZip}      
              onChange={handleZip}
            />
            <button type="button" onClick={handleZip}>Weiter</button>
        </>
    )
}

export default ZipView
